export class BaseResponse
{
    public readonly id:number;
    public readonly name:string;
    public readonly environmentName:string;
    public readonly createdAt:number;
    public readonly createdBy:string;
    public readonly createdById:number;

    constructor(json:any)
    {
        this.id = json['id'];
        this.name = json['name'];
        this.environmentName = json['environmentName'];
        this.createdAt = json['createdAt'];
        this.createdBy = json['createdBy'];
        this.createdById = json['createdById'];
    }
}
